import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "../App.css";

import breath1 from "../assets/breathwork1.jpeg";
import breath2 from "../assets/breathwork2.jpeg";
import breath3 from "../assets/breathwork3.jpeg";

const BreathworkSwiper = () => {
  const images = [breath1, breath2, breath3, breath1, breath2, breath3];

  return (
    <Swiper
      modules={[Autoplay]}
      centeredSlides={true}
      loop={true}
      autoplay={{ delay: 2000, disableOnInteraction: false }}
      
      /* ✅ Responsive Breakpoints */
      breakpoints={{
        0: { slidesPerView: 1, spaceBetween: 10 },      // mobile
        480: { slidesPerView: 1.2, spaceBetween: 15 },  // small phones
        768: { slidesPerView: 2, spaceBetween: 20 },    // tablets
        992: { slidesPerView: 3, spaceBetween: 30 },    // desktop
      }}

      className="horizontalImageSwiper"
    >
      {images.map((img, index) => (
        <SwiperSlide key={index} className="custom-horizontal-slide">
          <div className="slide-overlay-wrapper">
            <img
              src={img}
              alt={`Slide ${index + 1}`}
              className="horizontal-image"
            />
            <div className="side-dark-overlay"></div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default BreathworkSwiper;